import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "meta.gestao-veicular.cookie-consent";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try { if (!localStorage.getItem(STORAGE_KEY)) setVisible(true); }
    catch { setVisible(true); }
  }, []);

  if (!visible) return null;

  const accept = () => {
    try { localStorage.setItem(STORAGE_KEY, "true"); } catch { /* navegação privada: aceita apenas nesta sessão */ }
    setVisible(false);
  };

  return <div className="cookie-banner" role="region" aria-label="Aviso de cookies">
    <div className="cookie-banner-card">
      <div className="cookie-banner-copy">
        <span className="cookie-banner-icon" aria-hidden="true"><Cookie size={16}/></span>
        <div>
          <p className="cookie-banner-title">Privacidade e cookies</p>
          <p>Utilizamos armazenamento funcional e de sessão para manter você conectado e lembrar preferências da plataforma, em conformidade com a LGPD. Ao continuar navegando, você concorda com estas condições.</p>
        </div>
      </div>
      <button type="button" className="button primary" onClick={accept}>Entendi e aceito</button>
    </div>
  </div>;
}
